import { Injectable } from '@angular/core';
import { HttpHeader } from '../core/httpheader';
import { Picture } from './picture.model';
import { Http, RequestOptions, Response } from '@angular/http';
import { API_URL, API_Picture } from '../core/apiconfig';
import { Pictureupdate } from './pictureupdate.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class PictureService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http, ) {
        this.apiUrl = API_URL + API_Picture;
    }

  

    saveSignature(model: Pictureupdate[]) {
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + '/SavePicture', model, this.Http_Header_Request_Options).map(
            (res: Response) => res);       
    }

    getisValidSign(signatureID: any): Promise<Picture> {
        
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.get(this.apiUrl + '/IsValidPictureRequest/' + signatureID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as Picture)
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }


}



// WEBPACK FOOTER //
// ./SignClient/app/picture/picture.service.ts